import { createIndicator } from "@nexus/widget-kit";

/**
 * IP blocking indicator: the shared metric indicator on the `ip-blocking-metrics` source only, so an
 * author picks a metric of this domain and never a source.
 */
const indicator = createIndicator({
  id: "ip-blocking-indicator",
  name: "IP blocking indicator",
  description:
    "One or two figures of the IP blocking report — IPs detected and sent for blocking, blocking ratios per channel — with their trend.",
  source: "ip-blocking-metrics",
  sources: ["ip-blocking-metrics"],
});

export const { manifest, Component, defaultConfig, settings } = indicator;
export default indicator;
